import { useEffect, useState } from "react"
import { IAddHoldingProps } from "./IAddHolding"
import GTextSelectFree from "../../libs/textfield/GTextSelectFree";
import { Subject, debounceTime } from "rxjs"
import { ISelectRow } from "../../libs/dropdown/Dropdown";
import Portfolio from "../../models/Portfolio";
import _ from "lodash";
import FormGroup from "../../libs/form/FormGroup";
import axios from "axios"
import Prices from "../../models/Prices";
import usePortfolio from "../../hooks/PortfolioProvider";

const Search = new Subject<string>()

interface IHoldingNameProps extends IAddHoldingProps {
    controlName?:string
    form?:FormGroup
    ticker?:string
    price?:string
    setTicker?:Function
    setPrice?:Function
}
function getOptions(portfolio:Portfolio) {
    return portfolio.stockTickers.map(ticker => ({value:ticker,label:ticker}))
}
export function useTicker(props:IAddHoldingProps){
    const {transaction,holding} = props;
    const [ticker,setTicker] = useState<string>(transaction?.holding.id || holding?.id || "")
    return {ticker,setTicker}
}

export default function HoldingName(props:IHoldingNameProps){
    const {transaction,holding} = props;
    const {portfolio} = usePortfolio()
    const [options,setOptions] = useState<ISelectRow<string>[]>(getOptions(portfolio))
    const value = _.find(options, o => o.value==props.ticker)

    const refreshPrice = (ticker:string) => {
        if (!props.setPrice) return
        const p = Prices.i.get(ticker)
        if (p) props.setPrice(p.price.toString())
    }
    const textProps = {onBlur:(e:any) => props.ticker && refreshPrice(props.ticker)}
    const onChange = (e:any,selected:ISelectRow<string>|null,text:string) => {
        props.setTicker && props.setTicker(text!)
        if (text) Search.next(text)
        else setOptions(getOptions(portfolio))
    }
    const onSearch = async (text:string) => {
        try {
            const {data:list} = await axios.get<string[]>(`/1/prices/${text}?lookup=1`)
            setOptions(list.map(ticker => ({value:ticker,label:ticker})))
        }catch(e){}
    }
    useEffect(() => {
        const sub = Search.pipe(debounceTime(300)).subscribe({
            next:onSearch,
            error:() => {}
        })
        return () => { sub.unsubscribe() }
    },[])

    if (transaction || holding) return <></>
    else return <GTextSelectFree placeholder="Ticker" className="col2" defaultValue={value} options={options} onChange={onChange} 
        textProps={textProps} controlName={props.controlName} form={props.form}/>
}